import deserializers from '../serializers/versionMap';
import type { SerializerRegistry, SerializerResolver } from '@visualizer/types';
import type { SerializerKind } from './Constants';

type ConstructorLike = new (...args: any[]) => unknown;
type SerializerTarget = string | ConstructorLike | { name?: string } | null | undefined;
type SerializerLookupResult = ReturnType<SerializerResolver['findSerializer']>;

export function findSerializer(
    version: string,
    actClass: SerializerTarget,
    kindOfSerializer: SerializerKind | keyof SerializerRegistry
): SerializerLookupResult {
    if (!deserializers[version]) {
        throw new Error(`Version ${version} not found`);
    }

    let serializer: unknown;
    let serializerVersion = '';
    let currentVersion = version;
    const targetName = getName(actClass);

    while (!serializer) {
        const extractVersion = deserializers[currentVersion];
        if (!extractVersion) {
            throw new Error(`Version ${currentVersion} not found`);
        }

        const module = extractVersion[kindOfSerializer as keyof SerializerRegistry] as Record<string, unknown> | undefined;
        if (!module) {
            throw new Error(`Kind of serializer ${kindOfSerializer} not found`);
        }

        const serializerName = `${targetName}Serializer`;
        serializer = module[serializerName];
        serializerVersion = extractVersion.version;
        if (!serializer) {
            if (!extractVersion.previous) {
                throw new Error(`Serializer ${serializerName} not found for kind ${kindOfSerializer}`);
            }
            currentVersion = extractVersion.previous;
        }
    }

    console.log('For ', `${targetName} selected version`, serializerVersion);

    return { serializer, serializerVersion };
}

function getName(actClass: SerializerTarget): string {
    if (typeof actClass === 'string') {
        return actClass;
    }

    if (typeof actClass === 'function' && typeof actClass.name === 'string') {
        return actClass.name;
    }

    if (actClass && typeof actClass === 'object' && 'name' in actClass && typeof actClass.name === 'string') {
        return actClass.name;
    }

    return String(actClass ?? '');
}
